import { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import GlobalStyles from "@mui/material/GlobalStyles";
import { getActiveAppThemeRequest } from "../redux/Dashboard/dashboardSlice";
import { useAppTheme } from "./useAppTheme";
import { createAppMuiTheme } from "./createAppMuiTheme";

export default function AppThemeProvider({ children }) {
  const dispatch = useDispatch();
  const themeColors = useAppTheme();
  const muiTheme = useMemo(
    () => createAppMuiTheme(themeColors),
    [themeColors],
  );

  useEffect(() => {
    dispatch(
      getActiveAppThemeRequest({
        jeweller: process.env.REACT_APP_JEWELLER_ID,
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    const root = document.documentElement;
    root.style.setProperty("--app-primary", themeColors.primary);
    root.style.setProperty("--app-text", themeColors.text);
    root.style.setProperty("--app-scaffold-text", themeColors.scaffoldText);
    root.style.setProperty("--app-scaffold", themeColors.scaffold);
    root.style.setProperty("--app-border", themeColors.border);
    root.style.setProperty("--app-appbar", themeColors.appBar);
    root.style.setProperty("--app-container", themeColors.container);
  }, [themeColors]);

  return (
    <ThemeProvider theme={muiTheme}>
      <CssBaseline />
      <GlobalStyles
        styles={{
          body: {
            background: themeColors.scaffoldGradientColors,
            color: themeColors.scaffoldText,
            minHeight: "100vh",
          },
        }}
      />
      {children}
    </ThemeProvider>
  );
}
